var map = {
	"./arrow-down.svg": "./web/themes/custom/wearedigital/dev/icons/arrow-down.svg",
	"./arrow-left.svg": "./web/themes/custom/wearedigital/dev/icons/arrow-left.svg",
	"./arrow-right.svg": "./web/themes/custom/wearedigital/dev/icons/arrow-right.svg",
	"./arrow-up.svg": "./web/themes/custom/wearedigital/dev/icons/arrow-up.svg",
	"./big-arrow-down.svg": "./web/themes/custom/wearedigital/dev/icons/big-arrow-down.svg",
	"./big-arrow-left.svg": "./web/themes/custom/wearedigital/dev/icons/big-arrow-left.svg",
	"./big-arrow-right.svg": "./web/themes/custom/wearedigital/dev/icons/big-arrow-right.svg",
	"./big-arrow-up.svg": "./web/themes/custom/wearedigital/dev/icons/big-arrow-up.svg",
	"./download.svg": "./web/themes/custom/wearedigital/dev/icons/download.svg",
	"./email.svg": "./web/themes/custom/wearedigital/dev/icons/email.svg",
	"./facebook.svg": "./web/themes/custom/wearedigital/dev/icons/facebook.svg",
	"./instagram.svg": "./web/themes/custom/wearedigital/dev/icons/instagram.svg",
	"./logo.svg": "./web/themes/custom/wearedigital/dev/icons/logo.svg",
	"./phone.svg": "./web/themes/custom/wearedigital/dev/icons/phone.svg",
	"./twitter.svg": "./web/themes/custom/wearedigital/dev/icons/twitter.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./web/themes/custom/wearedigital/dev/icons sync recursive \\.svg$";